// Semestre académico: nombres y períodos "AAAA.S" (coincide con core.Semestre).

export const NOMBRE_SEMESTRE: Record<number, string> = { 0: "Anual", 1: "Otoño", 2: "Primavera", 3: "Verano" };

/** Opciones para elegir semestre, con los dos habituales primero. */
export const SEMESTRES: { value: number; label: string }[] = [
  { value: 1, label: "Otoño" },
  { value: 2, label: "Primavera" },
  { value: 0, label: "Anual" },
  { value: 3, label: "Verano" },
];

/** "2026.2" → "2026 Primavera" (devuelve el período tal cual si no calza). */
export function etiquetaPeriodo(periodo: string): string {
  const [ano, sem] = periodo.split(".");
  const nombre = NOMBRE_SEMESTRE[Number(sem)];
  return nombre ? `${ano} ${nombre}` : periodo;
}
